import { apiGetAsync, apiPostAsync } from "./helper";

export async function getUserProfile(token) {
	return await apiGetAsync("/User/me", token);
}

export async function getAllUsers(token, skip) {
	return await apiGetAsync(`/User/all?skip=${skip}`, token);
}

export async function postUserProfile(data) {
	return await apiPostAsync("/User", data);
}

export async function postVerifyEmail(uid, data) {
	return await apiPostAsync(`/User/${uid}/verify`, data);
}

export async function getUserPayPeriod(token, data) {
	return await apiGetAsync(`/User/${data}/payperiods`, token);
}

export async function getAdminUserNotes(token, data) {
	return await apiGetAsync(`/User/${data}/notes`, token);
}

export async function postAdminUserNotes(uid, data) {
	return await apiPostAsync(`/User/${uid}/notes`, data);
}